/**
 * AreaHeroImageSection – shared editorial section for Area hero/cover + gallery images.
 * Reuses the canonical AreaImagesSection (MediaImageManager with owner_type='area').
 * Used by both EditorAreaEditPage and AdminAreaEditPage.
 */

import { AreaImagesSection } from '@/components/admin/AreaImagesSection';

interface AreaHeroImageSectionProps {
  areaId?: string | null;
  draftSessionId?: string;
  /** If true, show a message that the area must be saved first. */
  requiresSave?: boolean;
}

export function AreaHeroImageSection({
  areaId,
  draftSessionId,
  requiresSave = false,
}: AreaHeroImageSectionProps) {
  if (requiresSave || !areaId) {
    return (
      <p className="text-xs text-muted-foreground">
        Spara området först för att kunna lägga till bilder.
      </p>
    );
  }

  return (
    <AreaImagesSection
      areaId={areaId}
      draftSessionId={draftSessionId}
    />
  );
}
